<template>
  <section class="quote-info">
    <div class="box">
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Expected Effective Date</td>
          <td v-copy="changeTime(formData.pcy_cmnt_dt)">
            {{ formData.is_eff_dt_delay&&isQuote?'ASAP':changeTime(formData.pcy_cmnt_dt) }}
            <span
              v-if="formData.is_eff_dt_delay&&!isQuote"
              class="asap">(ASAP)</span>
          </td>
        </tr>
        <tr class="tr">
          <td>Expected Expiry Date</td>
          <td v-copy="changeTime(formData.pcy_expry_dt)">{{ changeTime(formData.pcy_expry_dt) }}</td>
        </tr>
        <tr class="tr">
          <td>Studying Country</td>
          <td
            v-if="formData.country_id!=3"
            v-copy="getAllOptionName25('study_country',formData.country_id)">{{getAllOptionName25('study_country',formData.country_id)}}</td>
          <span
            v-else
            v-copy="`${getAllOptionName25('study_country',formData.country_id)} - ${formData.other_country}`">{{getAllOptionName25('study_country',formData.country_id)}} - {{formData.other_country}}</span>
        </tr>
      </table>
    </div>
    <template  v-if="isEndorsement">
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box">
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <span
          v-if="item.secondTile"
          class="title bold">{{ item.secondTile }}</span>
        <table
          class="table"
          :class="item.class">
          <template>
            <tr
              v-for="(sumItem,sumIndex) in item.list"
              v-show="sumItem.type!='array' || !sumItem.notShow"
              :key="sumIndex"
              class="tr oll">
              <td>{{ sumItem.name }}</td>
              <td v-if="formData[sumItem.field] === oldForm[sumItem.field]">
                <span v-if="!item.hasType">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </span>
                <span v-else>
                  {{ showCompareData(sumItem, formData[sumItem.typeName]) }}
                </span>
              </td>
              <td
                v-else
                class="compare">
                <span
                  v-if="!item.hasType"
                  class="text-line color-danger">
                  {{ showCompare(sumItem, oldForm[sumItem.field]) }}
                </span>
                <span
                  v-else
                  class="text-line color-danger">
                  {{ showCompareData(sumItem, oldForm[sumItem.typeName]) }}
                </span>
                <span
                  v-if="!item.hasType"
                  class="color-success">
                  {{ showCompare(sumItem, formData[sumItem.field]) }}
                </span >
                <span
                  v-else
                  class="color-success">
                  {{ showCompareData(sumItem, formData[sumItem.typeName]) }}
                </span>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </template>
    <template v-else>
      <div
        v-for="(item,index) in compareData"
        :key="index"
        class="box"
        :class="item.boxClass" >
        <h3 v-if="!item.isBold&&item.title">{{ item.title }}</h3>
        <h2 v-if="item.isBold&&item.title">{{ item.title }}</h2>
        <span
          v-if="item.secondTile"
          class="title bold">{{ item.secondTile }}</span>
        <table
          class="table"
          :class="item.class">
          <template >
            <tr
              v-for="(sumItem,sumIndex) in item.list"
              v-show="!sumItem.notShow"
              :key="sumIndex"
              class="tr">
              <td>{{ sumItem.name }}</td>

              <td
                v-if="sumItem.type == 'value'&&!sumItem.option"
                v-copy="sumItem.value">
                {{ sumItem.value }}
              </td>
              <td
                v-else-if="sumItem.type == 'value'&&sumItem.option"
                v-copy=" sumItem.value">
                {{ sumItem.value}}
              </td>
              <td
                v-else-if="sumItem.type == 'file'"
                class="blue pointer"
                @click="openFile(sumItem.value.url)">
                {{ sumItem.value&&sumItem.value.client_name }}
              </td>
              <td
                v-else-if="sumItem.type == 'array'"
              >
                <span
                  v-for="(sum,index) in sumItem.value"
                  :key="'sum'+index"
                  v-copy="sum.name">{{sum.name}}<br></span>
              </td>
              <td
                v-else
                v-copy="showCompare(sumItem, formData[sumItem.field],sumItem.field)">
                {{ showCompare(sumItem, formData[sumItem.field],sumItem.field) }}
                <email-tooltip
                  v-if="sumItem.field == 'email'"
                  :email="formData.email"></email-tooltip>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </template>
    <!--    <div class="box">-->
    <!--      <div class="table mg-b-10">-->
    <!--        <div class="tr">-->
    <!--          <span>Effective Date</span>-->
    <!--          <span>{{ formData.pcy_cmnt_dt }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Expiry Date</span>-->
    <!--          <span></span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Studying Country</span>-->
    <!--          <span></span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    -->
    <!--    <div class="box">-->
    <!--      <h2>Policyholder Detail</h2>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Title</span>-->
    <!--          <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Last Name</span>-->
    <!--          <span>{{ formData.isrd_lst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>First Name</span>-->
    <!--          <span>{{ formData.isrd_fst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Date of Birth</span>-->
    <!--          <span>{{ formData.isrd_dob_date }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>HKID Number</span>-->
    <!--          <span>{{ formData.id_no }}</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Room</span>-->
    <!--          <span>{{ formData.addr_room }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Floor</span>-->
    <!--          <span>{{ formData.addr_floor }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Block</span>-->
    <!--          <span>{{ formData.addr_block }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Building / Estate</span>-->
    <!--          <span>{{ formData.addr_building }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Street</span>-->
    <!--          <span>{{ formData.addr_street }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>District</span>-->
    <!--          <span>{{ getAreaName('district', formData.addr_district) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Area</span>-->
    <!--          <span>{{ getAreaName('area', formData.addr_area) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Country / Region</span>-->
    <!--          <span>{{ getAreaName('region', formData.addr_region) }}</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Mobile Number</span>-->
    <!--          <span></span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Email</span>-->
    <!--          <span>{{ formData.email }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Are you the Insured student?</span>-->
    <!--          <span></span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Are you the Insured student's Parent or Guardian?</span>-->
    <!--          <span></span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="box">-->
    <!--      <h2>Insured Student Information</h2>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Title</span>-->
    <!--          <span>{{ getOptionName('titleOptions', formData.isrd_title) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Last Name</span>-->
    <!--          <span>{{ formData.isrd_lst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>First Name</span>-->
    <!--          <span>{{ formData.isrd_fst_nm }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Date of Birth</span>-->
    <!--          <span>{{ formData.isrd_dob_date }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Relationship</span>-->
    <!--          <span></span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>HKID Number</span>-->
    <!--          <span>{{ formData.id_no }}</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->




    <!--    <div class="box">-->
    <!--      <h2>Overseas Studying Institution</h2>-->
    <!--      <div class="table">-->
    <!--        <div class="tr">-->
    <!--          <span>Room</span>-->
    <!--          <span>{{ formData.addr_room }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Floor</span>-->
    <!--          <span>{{ formData.addr_floor }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Block</span>-->
    <!--          <span>{{ formData.addr_block }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Building / Estate</span>-->
    <!--          <span>{{ formData.addr_building }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Street</span>-->
    <!--          <span>{{ formData.addr_street }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>District</span>-->
    <!--          <span>{{ getAreaName('district', formData.addr_district) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Area</span>-->
    <!--          <span>{{ getAreaName('area', formData.addr_area) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Country / Region</span>-->
    <!--          <span>{{ getAreaName('region', formData.addr_region) }}</span>-->
    <!--        </div>-->
    <!--        <div class="tr">-->
    <!--          <span>Country/ Territory</span>-->
    <!--          <span></span>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--    </div>-->

  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'StudentQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    title: {
      type: Boolean,
      default: true
    },
    oldForm: {
      type: Object,
      default: () => ({})
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showCompany:{
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions25
    },
    compareData() {
      let {benefit_coverage={},student_info={},acc_parent_info={},quote_coverage_list={}} = this.formData||{}
      let {acc_parent_guard_cvr=false} = benefit_coverage||{}
      let hasAcc =acc_parent_guard_cvr
      student_info = student_info||{}
      let benefitsList = this[`allOptions${this.formData.class_id}`].benefits || []
      let extra_arr =[]
      if(benefitsList.length > 0){
        extra_arr = benefitsList.filter(item => {
          return this.formData.benefits.includes(item.id)
        })
      }
      let list = [
        // {
        //   title: '',
        //   class: 'mg-b-10',
        //   list:
        //     [
        //       {
        //         name: 'Expected Effective Date',
        //         field: 'pcy_cmnt_dt',
        //         isTime:true
        //       },
        //       {
        //         name: 'Expected Expiry Date',
        //         field: 'pcy_expry_dt',
        //         isTime:true
        //         // option:10
        //       },
        //       {
        //         name: 'Studying Country',
        //         field:'country_id',
        //         fieldCode:'study_country',
        //         option:25,
        //         value: this.getAllOptionName25('study_country',this.formData.country_id),
        //         type: 'value',
        //       },
        //     ]
        // },
        {
          title: 'Policyholder Detail',
          isCompare: false,
          isBold: true,
          hasType:false,
          list: [
            {
              name: 'Title',
              field: 'isrd_title',
              fieldCode: 'titleOptions',
              option: 1
            }, {
              name: 'Last Name',
              field: 'isrd_lst_nm',

            }, {
              name: 'First Name',
              field: 'isrd_fst_nm'
            }, {
              name: 'Date of Birth',
              field: 'isrd_dob_date',
            }, {
              name: this.formData.id_type==1?'HKID':'Passport',
              field: 'id_no'
            }, {
              name: 'Nationality',
              field: 'id_nationality_seq_language',
              notShow: this.formData.id_type == 1
            },{
              name: 'Mobile Number',
              field: 'mobile_no',

            },
            {
              name: 'Email',
              field: 'email',
            },
            {
              name: 'Occupation',
              field: 'occ',
            },
            {
              name: 'Policyholder and student is the same person?',
              value: this.getOptionName('yesNoOptions',this.formData.hldr_is_student_ind),
              type:'value'
              // fieldCode: 'occupation',
              // option: 26,
            },
            {
              name: 'Optional Benefits',
              field: 'benefits',
              type:'array',
              value:extra_arr
            },
            {
              name: 'Insurer',
              field: 'company_language',
              notShow:!this.showCompany
            },
          ],
        },
        {
          title: 'Correspondence Address',
          isBold: false,
          list: [
            {
              name: 'Room',
              field: 'addr_room'
            }, {
              name: 'Floor',
              field: 'addr_floor'
            }, {
              name: 'Block',
              field: 'addr_block'
            }, {
              name: 'Building / Estate',
              field: 'addr_building'
            }, {
              name: 'Street',
              field: 'addr_street'
            }, {
              name: 'District',
              field: 'addr_district',
              addressCode: 'district',
              isAddress: true
            }, {
              name: 'Area',
              field: 'addr_area',
              addressCode: 'area',
              isAddress: true
            }, {
              name: 'Country / Region',
              field: 'addr_region',
              isAddress: true,
              addressCode: 'region'
            },
          ]
        },
        {
          title: 'Insured Student Details',
          isCompare: true,
          isBold: true,
          hasType:true,
          list: [
            {
              name: 'Title',
              value: this.getOptionName('titleOptions', student_info.student_title),
              typeName:'student_info',
              field:'student_title',
              option:1,
              fieldCode:'titleOptions',
              type: 'value'
            },
            {
              name: 'Last Name',
              value: student_info.student_lst_nm,
              typeName:'student_info',
              field:'student_lst_nm',
              type: 'value'
            }, {
              name: 'First Name',
              value: student_info.student_fst_nm,
              typeName:'student_info',
              field:'student_fst_nm',
              type: 'value'
            }, {
              name: 'Date of Birth',
              value:this.changeTime(student_info.student_dob),
              typeName:'student_info',
              field:'student_dob',
              isTime:true,
              type: 'value'
            },
            {
              name: student_info.id_type==1?'HKID':'Passport',
              value: student_info.student_id_no,
              typeName:'student_info',
              field:'student_id_no',
              type: 'value'
            },
            {
              name: 'Relationship to Policyholder',
              value:this.getAllOptionName25('student_relation',student_info.student_rel),
              field:'student_rel',
              fieldCode:'student_relation',
              option:2,
              typeName:'student_info',
              type: 'value'
            },
            {
              name: 'Overseas Studying Institution Name',
              value: student_info.student_ins_nm,
              field:'student_ins_nm',
              typeName:'student_info',
              type: 'value'
            },
            {
              name: 'Overseas Studying Institution Address',
              value: student_info.student_addr,
              field:'student_addr',
              typeName:'student_info',
              type: 'value'
            },
          ],
        },
      ]
      let arr = []
      if(hasAcc)
        arr = [
          {
            title: 'Optional Benefits Details',
            secondTile:'Accompanying Parent or Guardian Details',
            isCompare: true,
            isBold: true,
            hasType:true,
            list: [
              {
                name: 'Title',
                value: this.getOptionName('titleOptions', acc_parent_info.accompanying_title),
                typeName:'acc_parent_info',
                field:'accompanying_title',
                option:1,
                fieldCode:'titleOptions',
                type: 'value'
              }, {
                name: 'Last Name',
                value: acc_parent_info.accompanying_lst_nm,
                typeName:'acc_parent_info',
                field:'accompanying_lst_nm',
                type:'value'
              }, {
                name: 'First Name',
                value: acc_parent_info.accompanying_fst_nm,
                typeName:'acc_parent_info',
                field:'accompanying_fst_nm',
                type:'value'
              },  {
                name: acc_parent_info.id_type==1?'HKID':'Passport',
                value: acc_parent_info.accompanying_id_no,
                typeName:'acc_parent_info',
                field:'accompanying_id_no',
                type:'value'
              },
              {
                name: 'Date of Birth',
                value: acc_parent_info.accompanying_dob_date,
                typeName:'acc_parent_info',
                field:'.accompanying_dob',
                isTime:true,
                type:'value'
              },
              {
                name: 'Relationship to Insured Student',
                value: acc_parent_info.accompanying_rel_language,
                typeName:'acc_parent_info',
                field:'.accompanying_rel',
                fieldCode:'accompanying_relation',
                option:2,
                type:'value'
              },
            ],
          },
        ]
      let arr1 = [
        // {
        //   title: 'Upload Document',
        //   isCompare: false,
        //   isBold: true,
        //   list: [
        //     {
        //       name: 'Policyholder',
        //       field: '',
        //
        //     }, {
        //       name: 'Insured Student',
        //       field: ''
        //     }, {
        //       name: 'Accompanying Parent or Guardian HKID',
        //       field: ''
        //     }
        //   ]
        // }
      ]
      let arrData = [...arr,...arr1]
      return list.concat(arrData)
    },
  },
  methods:{
    getClientName(data){
      let {client_name=''} = data||''
      return client_name
    },
    openFile(url) {
      if(url) {
        window.open(url, '_blank')
      }
    },
    showCompareData(item,data){
      let change = ''
      change = data[item.field]
      if(item.option){
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, data[item.field])
            break
          case 2:
            change = this.getAllOptionName25(item.fieldCode, data[item.field])
            break
        }
      }
      if(item.isTime)
        change = dayjs(data[item.field]).format('DD-MM-YYYY')
      return change

    },
    changeTime(time){
      if(!time)return  ''
      else
        return dayjs(time).format('DD-MM-YYYY')
    },
    showCompare(item, field,sunF) {
      var change = field
      if(item.isTime)
        change = dayjs(field).format('DD-MM-YYYY')
      if (item.option) {
        switch (item.option) {
          case 1:
            change = this.getOptionName(item.fieldCode, field)
            break
          case 10:
            let {pcy_cmnt_dt=''} = this.formData||{}
            change=pcy_cmnt_dt?dayjs(pcy_cmnt_dt).add(1,'year').format('YYYY-MM-DD'):''
            break
          case 25:
            change = this.getAllOptionName25(item.fieldCode, field)
            break
        }
      }
      if (item.isAddress) {
        change = this.getAreaName(item.addressCode, field)
      }
      return change
    },
    getName(id){
      let data = this.nationalityOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    }
  }
}
</script>
<style lang="scss" scoped>
.quote-info {
  .box {
    margin-bottom: 15px;
  }
  .mg-b-0 {
    margin-bottom: 0!important;
  }

  .title {
    display: block;
    padding: 15px 0;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }

  .table {
    .tr {
      .compare {
        display: flex;
        align-items: center;

        & > span {
          flex: 1;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
